import React from 'react';
import { Skeleton } from '@execonline-inc/execonline-ui';

const LearningCollectionsSkeleton: React.FC = () => (
  <div className="mb-6 mt-4 rounded bg-white p-4">
    {/* Header */}
    <Skeleton variant="text" size="lg" className="mb-4" style={{ width: '180px' }} />

    {/* Collection items */}
    <div className="flex flex-col gap-2">
      {[...Array(7)].map((_, index) => (
        <div key={index} className="rounded-sm px-3 py-3">
          {/* Collection name */}
          <Skeleton variant="text" size="md" className="mb-2" style={{ width: '75%' }} />

          {/* Meta information */}
          <div className="flex items-center gap-2 text-[13px]">
            <Skeleton variant="text" size="sm" style={{ width: '80px' }} />
            <span className="text-gray-400">|</span>
            <Skeleton variant="text" size="sm" style={{ width: '120px' }} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default LearningCollectionsSkeleton;
